import { baseApi } from "app/baseApi";
import { apiTags } from "app/store/apiTags";
import { arrayToObject } from "utils/object-util";

const apiPrefix = 'vms';
export const vmsApi = baseApi.injectEndpoints({
    reducerPath: 'vmsApi',
    endpoints: (builder) => ({
        getVmsDasboardStats: builder.query({
            query: ({ vendorId, clientId, clientAccountId, startDate, endDate }) => `${apiPrefix}/stats?${vendorId ? `vendorId=${vendorId}` : ''}${clientId ? `&clientId=${clientId}` : ''}${clientAccountId ? `&clientAccountId=${clientAccountId}` : ''}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`,
            transformResponse: (response) => {
                var woLookup = arrayToObject(response.services, 'workOrderId');
                return {
                    ...response,
                    onTimeCompletionInfoWithWo: response.onTimeCompletionInfo?.map(c => ({
                        ...c,
                        ...woLookup[c.workOrderId]
                    })),
                    turnaroundTimeInfoWithWo: response.turnaroundTimeInfo?.map(c => ({
                        ...c,
                        ...woLookup[c.workOrderId]
                    })),
                    reworkServiceInfoWithWo: response.reworkServiceInfo?.map(c => ({
                        ...c,
                        ...woLookup[c.workOrderId]
                    }))
                }
            }
            // providesTags: (result, error, vendorId) =>
            //     result ?
            //         [{ type: apiTags.VMS, id: vendorId }] :
            //         [{ type: apiTags.VMS, id: 'LIST' }],
        }),
        getAllVendors: builder.query({
            query: () => `${apiPrefix}/vendors`,
            providesTags: (result, error, arg) => [{ type: apiTags.VMS, id: `LIST` }, { type: apiTags.VENDOR, id: 'VENDORS' }],
        }),
        getVmsVendorStats: builder.query({
            query: ({ id }) => `${apiPrefix}/stats/${id}`,
            providesTags: (result, error, arg) => [{ type: apiTags.VMS, id: `LIST` }],
        }),

    })
});


export const {
    useGetVmsDasboardStatsQuery,
    useGetAllVendorsQuery,
    useGetVmsVendorStatsQuery
} = vmsApi;
